import { useGetQuery } from 'common/hooks';
import { ApiPaths } from '../constants/apiPaths';
import { useOrganization } from 'core/stores/hooks/useOrganization';

export const useFetchAnalyticsDashboardUrl = () => {
  const organization = useOrganization();

  return useGetQuery<{ url: string }>(ApiPaths.analyticsDashboardUrl, {
    queryKey: [ApiPaths.analyticsDashboardUrl, organization.id]
  });
};
